import { productCarouselStyles } from "@insite/content-library/Widgets/Common/ProductCarousel";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon, { IconWrapper } from "@insite/mobius/Icon";
import ArrowLeft from "@insite/mobius/Icons/ArrowLeft";
import ArrowRight from "@insite/mobius/Icons/ArrowRight";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@store/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

// TODO: Refactor external
export const arrowButton = () => {
    return css`
        border: 0;
        padding: 0;
        min-height: 30px;
        width: 30px;
        border-radius: 50%;
        z-index: 2;
        > span:nth-child(2) {
            display: none;
        }
        ${IconWrapper} {
            height: auto;
            width: auto;
            margin-right: 0px;
            > svg {
                height: 16px;
                width: 28px;
            }
        }
    `;
};

Object.assign(productCarouselStyles, {
    titleText: {
        variant: "h2",
        css: css`
            text-align: center;
            margin-bottom: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            border-top: 1px solid ${COLORS.border.base};
                            padding-top: ${TYPOGRAPHY.spacing.base};
                        `,
                    ],
                    "max",
                )}
        `,
    },
    prevArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            ${arrowButton()}
        `,
        icon: {
            src: ArrowLeft,
            position: "left",
        },
    },
    nextArrowButton: {
        variant: "secondary",
        color: "text.main",
        css: css`
            ${arrowButton()}
        `,
        icon: {
            src: ArrowRight,
            position: "left",
        },
    },
    carouselSlidesContainer: {
        css: css`
            display: flex;
            > div {
                border: 1px solid ${COLORS.border.base};
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                border: none;
                            `,
                        ],
                        "max",
                    )}
                text-align: center;
                transition: box-shadow 0.3s;
                &:hover {
                    box-shadow: ${getProp("theme.shadows.small")};
                }
            }
        `,
    },
});
